module.exports = __webpack_public_path__ + "img/reports.b21671ec.svg";